<template>
  <div class="home">
    <div class="head-title">我的资料</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <div class="tianjia_jiben">
            <el-descriptions title="基本信息">
              <el-descriptions-item label="账号">{{
                form.tableData.account
              }}</el-descriptions-item>
              <el-descriptions-item label="密码">*******
                <span style="margin-left: 12px; color: #3a8ee6;cursor: pointer;" type="text"
                  @click="dialogVisible = true">修改密码</span></el-descriptions-item>
              <el-descriptions-item label="手机号"><span>{{ form.tableData.phone }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="备用电话">
                {{ form.tableData.phoneTwo }}
              </el-descriptions-item>
              <el-descriptions-item label="地址">{{
                form.tableData.province + form.tableData.city
              }}</el-descriptions-item>
              <el-descriptions-item label="企业名称">{{
                form.tableData.enterpriseName
              }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                form.tableData.addtime
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="tianjia_jiben">
            <el-descriptions title="其他信息">
              <el-descriptions-item label="营业执照">
                <span class="yingye">
                  <el-image style="width: 7.0rem; height: 7.0rem" :src="`${form.tableData.enterprisePhoto}`"
                    :preview-src-list="[form.tableData.enterprisePhoto]" fit="scale-down"></el-image>
                  &emsp;<span style="margin-left: 12px; color: #3a8ee6" type="text"
                    @click="dialogVisibles = true">修改营业执照</span>
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="折扣">{{
                form.tableData.levelName
              }}</el-descriptions-item>
              <el-descriptions-item label="余额">{{
                form.tableData.money
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="tianjia_jiben fapiao">
            <el-descriptions title="发票信息">
              <el-descriptions-item label="纳税人识别号">
                {{ form.tableData.pay_number }}
              </el-descriptions-item>
              <el-descriptions-item label="开发票详细地址">{{
                form.tableData.address_detail
              }}</el-descriptions-item>
              <el-descriptions-item label="发票电话">{{
                form.tableData.tel_phone
              }}</el-descriptions-item>
              <el-descriptions-item label="发票开户行及账号">{{
                form.tableData.account_number
              }}</el-descriptions-item>
              <el-descriptions-item label="收货人姓名">{{ form.tableData.get_name }}
              </el-descriptions-item>
            </el-descriptions>
            <el-button type="primary" @click="dialogVisibless = true">修改发票信息</el-button>
          </div>
        </div>

        <!-- 修改密码弹出层 -->
        <el-dialog title="修改密码" center :visible.sync="dialogVisible" width="30%">
          <el-form ref="formMf" :model="form" label-width="12.0rem" :rules="rules">
            <el-form-item label="初始密码">
              <el-input clearable v-model="formMf.name" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input clearable v-model="formMf.phone" show-password prop="phone"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input clearable v-model="formMf.phoneTwo" show-password prop="phoneTwo"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 发票信息修改 -->
        <el-dialog title="信息修改" center :visible.sync="dialogVisibless" width="30%">
          <el-form ref="formxx" :model="form" label-width="14.0rem" :rules="rules">
            <el-form-item label="纳税人识别号">
              <el-input clearable v-model="formxx.pay_number"></el-input>
            </el-form-item>
            <el-form-item label="开发票详细地址">
              <el-input clearable v-model="formxx.address_detail"></el-input>
            </el-form-item>
            <el-form-item label="发票电话">
              <el-input clearable v-model="formxx.tel_phone"></el-input>
            </el-form-item>
            <el-form-item label="发票开户行及账号">
              <el-input clearable v-model="formxx.account_number"></el-input>
            </el-form-item>
            <el-form-item label="收货人的姓名">
              <el-input clearable v-model="formxx.get_name"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibless = false">取 消</el-button>
            <el-button type="primary" @click="changeInvoiceMessage()">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 营业执照 -->
        <el-dialog title="信息修改" center :visible.sync="dialogVisibles" width="30%">
          <el-form ref="formxx" :model="form" label-width="14.0rem" :rules="rules">
            <el-form-item label="营业执照">
              <el-upload class="upload-demo"
                :action="`${baseURL}/api/Alioss/uploadTotal?agenttoken=${username.agenttoken}`"
                :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
                :on-exceed="handleExceed" :file-list="fileList" :on-success="chenggong">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibles = false">取 消</el-button>
            <el-button type="primary" @click="imageUpload">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
import Vue from "vue";
export default {
  data() {
    return {
      baseURL: this.axios.defaults.baseURL,
      form: {
        tableData: [],
        enterprisePhoto: "",
      },
      url: "https://api.weijub.com",
      formMf: {
        name: "",
        phone: "",
        phoneTwo: "",
        get_name: "",
      },
      formxx: {
        pay_number: "",
        address_detail: "",
        tel_phone: "",
        account_number: "",
        get_name: "",
      },
      //图片上传
      fileList: [],
      dialogVisible: false,
      dialogVisibles: false,
      dialogVisibless: false,
      username: [],
      title: {},
      rules: {
        //备用手机
        phone: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        //确认密码
        phoneTwo: [
          {
            min: 6,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.headlgetOneAgentUserInfo();
  },
  methods: {
    imageUpload() {
      this.axios
        .post(
          "/api/Agent/changeInvoiceMessage",
          qs.stringify({
            id: this.form.tableData.id,
            agenttoken: this.username.agenttoken,
            enterprisePhoto: this.form.enterprisePhoto.url,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          if (res.data.code == 1) {
            this.headlgetOneAgentUserInfo();
            this.dialogVisibless = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.dialogVisibless = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    //图片上传
    chenggong(response, file, fileList) {
      this.form.enterprisePhoto = file.response.data;
    },
    //图片删除后返回的信息
    handleRemove(file, fileList) { },
    //上传成功后点击返回的图片信息
    handlePreview(file) { },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    changeInvoiceMessage() {
      this.axios
        .post(
          "/api/Agent/changeInvoiceMessage",
          qs.stringify({
            id: this.form.tableData.id,
            agenttoken: this.username.agenttoken,
            pay_number: this.formxx.pay_number,
            address_detail: this.formxx.address_detail,
            tel_phone: this.formxx.tel_phone,
            account_number: this.formxx.account_number,
            get_name: this.formxx.get_name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          if (res.data.code == 1) {
            this.headlgetOneAgentUserInfo();
            this.dialogVisibless = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.dialogVisibless = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    // 密码校验
    // inputphoneTwo() {
    //   if (this.formMf.phone != this.formMf.phoneTwo) {
    //     this.$message.error("密码请保持一致");
    //     return;
    //   }
    // },
    // 提交过后输出的数据\
    headlgetOneAgentUserInfo() {
      this.axios
        .post(
          "/api/agent/getOneAgentUserInfo",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.form.tableData = res.data.data;
          this.formxx.pay_number = res.data.data.pay_number;
          this.formxx.address_detail = res.data.data.address_detail;
          this.formxx.tel_phone = res.data.data.tel_phone;
          this.formxx.account_number = res.data.data.account_number;
          this.formxx.get_name = res.data.data.get_name;
        })
        .catch(function (err) {
          Toast("连接超时，请刷新网页");
        });
    },

    //修改密码
    vak() {
      if (this.formMf.phone != this.formMf.phoneTwo) {
        this.$message.error("密码请与新密码保持一致");
        this.dialogVisible = true;
        return;
      } else {
        this.axios
          .post(
            "/api/agent/changePassword",
            qs.stringify({
              id: this.username.id,
              agenttoken: this.username.agenttoken,
              old_password: this.$md5(this.formMf.name),
              new_password: this.$md5(this.formMf.phone),
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            if (res.data.code == 1) {
              this.dialogVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) { });
      }
    },
  },
};
</script>
<style lang="scss">
.el-descriptions__body {
  background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}

.qita>span>span {
  font-size: 2.0rem;
}

.namesd {
  margin-bottom: 3.0rem;
}

.namesd>span {
  width: 25%;
  color: #5C5C5C;
  font-size: 14px;
}

.none {
  display: flex;
  align-items: flex-start;
}

.qita {
  margin-top: 2.0rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.namesd {
  margin-top: 2.0rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.tianjia_jiben>span {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.tianjia {
  width: 100%;
  padding: 2.0rem;
  border: solid 1px #DCDCDC;
}

.body_html {
  width: 100%;
  height: 100%;
}

.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 31px;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia_jiben {
  padding: 2.0rem 0;
  border-bottom: 1px solid #DCDCDC;
}

.label {
  width: 10.0rem;
  display: inline-flex;
}

.yingye {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.fapiao {
  border-bottom: 0;
}
</style>

